export var LogCacheLimit = 4000;
export var noop = function () { };
export var dummyConsole = {
    trace: noop,
    debug: noop,
    info: noop,
    log: noop,
    warn: noop,
    error: noop,
};
/**
 * 日志存储的模式, bitmap标识，可以多种模式组合
 */
export var LogMode;
(function (LogMode) {
    /** 在控制台中输出 */
    LogMode[LogMode["console"] = 1] = "console";
    /** 存入缓存中 */
    LogMode[LogMode["cache"] = 2] = "cache";
})(LogMode || (LogMode = {}));
